import React, { useRef, useState } from 'react';
import styles from './VideoHero.module.scss';
import { Typography } from '@mui/material';
import { ArrowForward } from '@material-ui/icons';
import PauseIcon from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { IconButton } from '@mui/material';
import { useRouter } from 'next/router';

export default function VideoHero() {
  const videoRef = useRef(null);
  const router = useRouter();
  const [paused, setPaused] = useState(false);

  const videoControl = (status) => {
    let player = new Vimeo.Player(videoRef.current);
    if (status) {
      player.pause();
    } else {
      player.play();
    }
    setPaused(status);
  };

  return (
    <div className={styles.wapper}>
      <div className={styles.blurContainer}></div>
      <div className={styles.container}>
        <div className={styles.mainContentArea}>
          <div className={styles.heroContent}>
            <Typography
              variant="h1"
              color="white"
              className={styles.heroMainContent}
            >
              What if You Could Eliminate Pain Instead of Just Masking It?
            </Typography>
            <Typography
              variant="p1"
              color="white"
              className={styles.heroSubtitle}
            >
              Relief Factor is a safe and effective option to reduce or even
              eliminate pain all day
            </Typography>
            <div>
              <IconButton
                className={styles.arrowBtn}
                onClick={() =>
                  router.push('#howitworks', undefined, { scroll: false })
                }
              >
                <ArrowForward />
              </IconButton>
            </div>
          </div>
          <div className={styles.videoControl}>
            <IconButton
              className={styles.arrowBtn}
              onClick={() => videoControl(!paused)}
            >
              {paused ? <PlayArrowIcon /> : <PauseIcon />}
            </IconButton>
          </div>
        </div>
      </div>
      <div className={styles.videoBg}>
        <iframe
          id="videoPlayer"
          ref={videoRef}
          src="https://player.vimeo.com/video/946390374?background=1&muted=1&autopause=1"
          frameBorder="0"
          allow="autoplay; fullscreen"
          allowFullScreen
          className={styles.bgVideo}
        ></iframe>
      </div>
    </div>
  );
}
